import {
    CUT_REGISTRATION_SAVE_REQ,
    CUT_REGISTRATION_SAVE_REQ_FAIL,
    CUT_REGISTRATION_SAVE_REQ_SUCCESS
} from "./cutRegistrationTypes";
import axios from "axios";
import store from "../../store";

export const cutRegistrationAction = () => {
    return {
        type: CUT_REGISTRATION_SAVE_REQ
    }
}

export const cutRegistrationActionSuccess = (cutRegRequestSuccess) => {
    return {
        type: CUT_REGISTRATION_SAVE_REQ_SUCCESS,
        payload: cutRegRequestSuccess
    }
}
export const cutRegistrationActionFail = (error) => {
    return {
        type: CUT_REGISTRATION_SAVE_REQ_FAIL,
        payload: error
    }
}

export const saveCutRegistration = (cutRegFormData) => {
    return (dispatch) => {
        dispatch(cutRegistrationAction());
        axios.post(process.env.REACT_APP_CUT_REG_BASE_URL +"/register/", cutRegFormData)
            .then(response => {
                const successResponse = response.data
                dispatch(cutRegistrationActionSuccess(successResponse))
            })
            .catch(error => {
                const failureResponse = error.data
                dispatch(cutRegistrationActionFail(failureResponse))
            })
    }
}
